export default __webpack_public_path__ + "static/media/icon_arkit.922234b1.svg";